import { render, staticRenderFns } from "./ViewStudentsViaSections.vue?vue&type=template&id=5331f5ed&scoped=true"
import script from "./ViewStudentsViaSections.vue?vue&type=script&lang=js"
export * from "./ViewStudentsViaSections.vue?vue&type=script&lang=js"
import style0 from "./ViewStudentsViaSections.vue?vue&type=style&index=0&id=5331f5ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331f5ed",
  null
  
)

export default component.exports